import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-pop-up',
  templateUrl: './modal-pop-up.component.html',
  styleUrls: ['./modal-pop-up.component.scss']
})
export class ModalPopUpComponent implements OnInit {
  @Input('responseMessage') responseMessage: string;
  @Output('triggerCloseEvent') closeEvent = new EventEmitter<any>();

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }
  public closePopUp(): void {
    if(this.responseMessage == "Thank you for taking the assessment. <br/>Please check your email for report."){
      this.router.navigate(['/']);
    }
    else{
      this.closeEvent.emit();
    }
  }

}
